import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import DoneIcon from "@mui/icons-material/Done";
import FormControl from "@mui/material/FormControl";
import DangerousIcon from "@mui/icons-material/Dangerous";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Box from "@mui/material/Box";
import Config from "conFig.js";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};

const permissionscolumn = [
  { field: "pmS_ID", headerName: "ID", width: 50, headerAlign: "center" },
  {
    field: "ctL_NAME",
    headerName: "Controller",
    width: 300,
    headerAlign: "center",
  },
  {
    field: "pmS_NAME",
    headerName: "Tên",
    width: 300,
    headerAlign: "center",
  },
];
const rolecolumns = [
  {
    field: "rolE_ID",
    headerName: "ROLE ID",
    width: 150,
    headerAlign: "center",
    cellClassName: "center",
  },
  {
    field: "rolE_NAME",
    headerName: "ROLE NAME",
    width: 150,
    headerAlign: "center",
  },
];
export default function RolePermission() {
  const [roles, setRoles] = React.useState([]);
  const [permissions, setPermissions] = React.useState([]);
  const [selectedroleRows, setSelectedroleRows] = React.useState([]);
  const [selectedpermissionRows, setSelectedpermissionRows] = React.useState(
    []
  );
  const init = [];
  const [initpermission, setInitpermission] = React.useState([]);
  const [alert, setAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [icon, setIcon] = React.useState(AddAlert);
  const [color, setColor] = React.useState("warning");
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const token = localStorage.getItem("token");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getroles = () => {
    var url = Config.backend + "/api/Roles/roles";
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setRoles(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getpermissions = () => {
    var url = Config.backend + "/api/permissions/permissions";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setPermissions(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getpermissionbyrole = (showMs) => {
    if (selectedroleRows.length == 1) {
      var role = selectedroleRows[0].rolE_ID;
      var url =
        Config.backend + "/api/permissions/permissionsbyrole?role=" + role;
      fetch(url)
        .then((res) => res.json())
        .then((data) => {
          if (data.length !== 0) {
            data.map((prop) => {
              init.push(prop.pmS_ID);
            });
            setInitpermission(init);
          } else {
            setInitpermission([]);
          }
          if (showMs) {
            showNotification(
              "Role " + role + " có " + data.length + " permissions",
              NotificationsIcon,
              "success"
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  const showNotification = (ms, icon, color) => {
    setAlert(true);
    setMessage(ms);
    setColor(color);
    setIcon(icon);
    setTimeout(function () {
      setAlert(false);
    }, 3000);
  };
  const capnhat = () => {
    if (selectedroleRows.length == 1) {
      var kq = [];
      selectedpermissionRows.map((prop) => {
        kq.push(prop.pmS_ID);
      });
      let url = Config.backend + "/api/Roles/phanpermission";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          rolEID: selectedroleRows[0].rolE_ID,
          pmsIds: kq,
        }),
      })
        .then((response) => {
          if (response.ok) {
            return response;
          }
          throw new Error("Something went wrong");
        })
        .then(() => {
          showNotification("Cập nhật thành công", DoneIcon, "success");
          getpermissionbyrole(false);
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
          showNotification("Cập nhật thất bại", DangerousIcon, "danger");
        });
    } else {
      showNotification("Vui lòng chọn Role", AddAlert, "warning");
    }
  };

  React.useEffect(() => {
    getpermissionbyrole(true);
  }, [selectedroleRows]);
  React.useEffect(() => {
    getroles();
    getpermissions();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12}>
        <FormControl style={{ width: "12%", marginTop: 5 }}>
          <Button
            color="primary"
            variant="contained"
            onClick={capnhat}
            style={{ height: 25 }}
          >
            Cập nhật
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={4}>
        <div style={{ height: 500, width: "100%", marginTop: 10 }}>
          <DataGrid
            getRowId={(row) => row.rolE_ID}
            rows={roles}
            columns={rolecolumns}
            rowsPerPageOptions={[]}
            hideFooter={true}
            checkboxSelection={false}
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRows = roles.filter((row) =>
                selectedIDs.has(row.rolE_ID)
              );
              setSelectedroleRows(selectedRows);
            }}
            rowHeight={30}
            headerHeight={35}
            sx={datagridSx}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={8}>
        <div style={{ height: 500, width: "100%", marginTop: 10 }}>
          <DataGrid
            getRowId={(row) => row.pmS_ID}
            rows={permissions}
            columns={permissionscolumn}
            rowsPerPageOptions={[]}
            hideFooter={true}
            selectionModel={initpermission}
            checkboxSelection
            onSelectionModelChange={(ids) => {
              setInitpermission(ids);
              const selectedIDs = new Set(ids);
              const selectedRows = permissions.filter((row) =>
                selectedIDs.has(row.pmS_ID)
              );
              setSelectedpermissionRows(selectedRows);
            }}
            rowHeight={30}
            headerHeight={35}
            sx={datagridSx}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={12} md={10} lg={8}>
        <Snackbar
          place="tc"
          color={color}
          icon={icon}
          message={message}
          open={alert}
          closeNotification={() => setAlert(false)}
          close
        />
      </GridItem>
    </GridContainer>
  );
}
